import { Component, OnInit, ViewChild } from '@angular/core';
import { CircularRequestComponent } from '../circular-request/circular-request.component';

@Component({
  selector: 'app-circular-request-clone-request',
  templateUrl: './circular-request-clone-request.component.html'
})

export class CircularRequestCloneRequestComponent implements OnInit {
  @ViewChild('circularsRequest',{static: false}) circularsRequest: CircularRequestComponent;

  constructor() { }

  ngOnInit() {}
  onCircularsRequestLoadedFlag(flag: boolean) {
    if(flag){
      this.circularsRequest.editModeAdmin = true;
    }
  }
}
